/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Observable from "./Observable";

export default class IncrementObservable extends Observable<number>
{
    constructor(value?: number)
    {
        if (value == null) { value = 0; }
        super(value);

        this.oldValue = 0;
    }

    public SetValue(value: number): this
    {
        if (this.value < value)
        {
            super.SetValue(value);
        }
        return this;
    }

    public Clear(): this
    {
        super.SetValue(0);
        this.oldValue = 0;
        return this;
    }
}
